import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";

// 1️⃣ Read language from cookie named "lang"
function getLangFromCookie(): "th" | "en" | null {
  const match = document.cookie.match(/(?:^|;\s*)lang=([^;]*)/);
  const val = match?.[1]?.toLowerCase();
  if (val === "thai" || val === "th") return "th";
  if (val === "en" || val === "english") return "en";
  return null;
}

// 2️⃣ Read language from URL param (?lang or ?language)
function getLangFromURL(): "th" | "en" | null {
  const params = new URLSearchParams(window.location.search);
  const langParam = params.get("language") || params.get("lang");
  const normalizedLang = langParam?.toLowerCase();

  if (normalizedLang === "thai" || normalizedLang === "th") return "th";
  if (normalizedLang === "en" || normalizedLang === "english") return "en";
  return null;
}

// 3️⃣ Read saved language from localStorage
const savedLang = localStorage.getItem("lang") as "th" | "en" | null;

// 4️⃣ Determine initial language: Cookie > URL > localStorage > fallback
const cookieLang = getLangFromCookie();
const urlLang = getLangFromURL();
const initialLang: "th" | "en" = cookieLang || urlLang || savedLang || "th";

// console.log(`i18n initialization:
//   URL language: ${urlLang}
//   Saved language: ${savedLang}
//   Initial language: ${initialLang}`); // for debugging

// 5️⃣ Persist resolved language to localStorage (if different from saved)
if (initialLang !== savedLang) {
  // console.log(`Persisting language to localStorage: ${initialLang}`); // for debugging
  localStorage.setItem("lang", initialLang);
}

// 6️⃣ Initialize i18next
i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: "th",
    supportedLngs: ["en", "th"],
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    react: { bindI18n: "languageChanged", useSuspense: false },
  });

// 7️⃣ Persist language changes whenever i18n.changeLanguage is called
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("lang", lng);
});

export default i18n;
